import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { AccountDetailsService } from '../services/account-details.service';
import { LoginService } from '../services/login.service';

declare var $: any;

@Component({
  selector: 'app-pay-now',
  templateUrl: './pay-now.component.html',
  styleUrls: ['./pay-now.component.css']
})
export class PayNowComponent implements OnInit {
  streetAddress: string;
  cityStateZip: string;
  acctNumber: string;
  
  constructor(
    private loginService: LoginService,
    private accountDetailsService: AccountDetailsService) {
  }

  ngOnInit() {
    this.loginService.getUserContext()
      .subscribe((ctx) => {
        if (ctx) {
          this.acctNumber = ctx.accountDetails[0].accountDetails.accountNumber;
          this.streetAddress = ctx.accountDetails[0].accountDetails.address1 + " " + (ctx.accountDetails[0].accountDetails.address2 !== null ? ctx.accountDetails[0].accountDetails.address2 : "");
          this.cityStateZip = ctx.accountDetails[0].accountDetails.city + ", " + ctx.accountDetails[0].accountDetails.state + " " + ctx.accountDetails[0].accountDetails.zipcode;
        }
      });
  }

  ngAfterViewChecked() {
    //let self = this;
    //$(document).ready(function () {
    //  var navListItems = $('div.setup-panel div a'),
    //    allWells = $('.setup-content'),
    //    allNextBtn = $('.nextBtn'),
    //    allPrevBtn = $('.prevBtn');

    //  allWells.hide();

    //  navListItems.click(function (e) {
    //    e.preventDefault();
    //    var $target = $($(self).attr('href')),
    //      $item = $(self);

    //    if (!$item.hasClass('disabled')) {
    //      navListItems.removeClass('btn-indigo').addClass('btn-default');
    //      $item.addClass('btn-indigo');
    //      allWells.hide();
    //      $target.show();
    //      $target.find('input:eq(0)').focus();
    //    }
    //  });

    //  allPrevBtn.click(function () {
    //    var curStep = $(self).closest(".setup-content"),
    //      curStepBtn = curStep.attr("id"),
    //      prevStepSteps = $('div.setup-panel div a[href="#' + curStepBtn + '"]').parent().prev().children("a");

    //    prevStepSteps.removeAttr('disabled').trigger('click');
    //  });

    //  allNextBtn.click(function () {
    //    var curStep = $(self).closest(".setup-content"),
    //      curStepBtn = curStep.attr("id"),
    //      nextStepWizard = $('div.setup-panel div a[href="#' + curStepBtn + '"]').parent().next().children("a"),
    //      curInputs = curStep.find("input[type='text'],input[type='url']"),
    //      isValid = true;

    //    $(".form-group").removeClass("has-error");
    //    for (var i = 0; i < curInputs.length; i++) {
    //      if (!curInputs[i].validity.valid) {
    //        isValid = false;
    //        $(curInputs[i]).closest(".form-group").addClass("has-error");
    //      }
    //    }

    //    if (isValid)
    //      nextStepWizard.removeAttr('disabled').trigger('click');
    //  });

    //  $('div.setup-panel div a.btn-indigo').trigger('click');
    //});
  }

}



// WEBPACK FOOTER //
// ./src/app/pay-now/pay-now.component.ts